import Mark from 'mark.js';
import React, { Component } from 'react';
import { Button, Col, Row, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../../content/css/ContractReviewer.css';
import { contractReviewerActions as actions } from '../../actions';
import AuthService from '../../services/auth.service';
import Viewer from '../../helpers/documentViewer';
import HighlightExportTexts from '../Highlight/HighlightExportTexts';
import TextSelector from 'text-selection-react';
import { LoadingIcon } from '../LoadingIcon';

var authService = new AuthService();
const HIGHLIGHT_SECTIONS = { GUIDANCE: 0, EXAMPLES: 1, EXPLANATION: 2, APPROVAL: 3 };

class ExportView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visibleSections: []
        };
    }

    componentDidMount() {
        const { docId } = this.props.match.params;
        if (this.props.id !== docId) this.props.requestDocumentAnalysis(docId);
    }

    render() {
        return (
            <React.Fragment>
                {this.props.isLoading &&
                    <LoadingIcon isFixed={true} />
                }

                {!this.props.isLoading &&
                    <React.Fragment>
                        <div className="export">
                            <HighlightExportTexts
                                highlights={this.props.highlights}
                                visibleSections={this.state.visibleSections}
                                isLoading={this.props.isLoading}
                            />
                        </div>
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

export default connect(
    state => state.contractReviewer,
    dispatch => bindActionCreators(actions, dispatch)
)(ExportView);



// WEBPACK FOOTER //
// ./src/components/DocumentViewer/ExportView.js